const coinbaseEscrowShowListingZone = (state = false, action) => {
  switch (action.type) {
      case 'SET_COINBASE_ESCROW_SHOW_LISTING_ZONE':
          return action.show
      default:
          return state
  }
}

export default coinbaseEscrowShowListingZone;